const getTranslationsByLocale = function(lang) {
  const da = {
    legal: {
      signup_disclaimer: `Ja, Mostly Code må gerne sende mig artikler og nyhedsbreve`,
      signup_nudge: `Uuuh, et lille klik ekstra. Det er så rart, når der er styr på formalia.`
    },
    firstname_input_placeholder: 'Dit fornavn',
    input_placeholder: 'Email adresse',
    submit_button_text: 'Tilmeld',
    success_message: 'Tak for din tilmelding 😎 🎉',
    error_message: 'Noget gik galt 😢',
    retry_link_text: 'Prøv igen'
  }

  const en = {
    legal: {
      signup_disclaimer: `Yes, Mostly Code may send me articles and newsletters`,
      signup_nudge: `Ah, just one more click. We love to get formalia right!`,
    },
    firstname_input_placeholder: "Your first name",
    input_placeholder: "Email address",
    submit_button_text: "Signup",
    success_message: "Thanks for signing up 😎 🎉",
    error_message: "Something went wrong 😢",
    retry_link_text: "Try again",
  }

  return lang === 'da-dk' ? da : en
}

export default getTranslationsByLocale
